import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Text from "./components/Text.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const advantagesList = [
  "Finansiering",
  "Forsikring",
  "Verksteder",
  "Dekk og felg",
  "Garantier",
  "Deler og utstyr",
  "Bilpleie",
  "Transport",
  "Regnskap",
  "Administrasjonsverktøy",
];

const MobilityPool = () => {
  const pageName = TradeOrgPages.MobilityPool;

  return (
    <Layout
      left={
        <>
          <Title title="Fordeler med Mobility Pool" />
          <Text text="Mobility Pool medlemmene forplikter seg til å følge forbrukerkjøpsloven og drive virksomheten med god forretningsskikk. Alltid gjøre det beste for kunden." />
          <Text text="Våre medlemmer har kompetanse, avtaler og verktøy som gjør ditt bilkjøp enklere og tryggere. Mobility Pool AS er en innkjøpsgruppe på over 1400 bruktbilforhandlere." />
          <div className="mt-40">
            <List
              title="Dette sikrer bilhandleren meget gode vilkår for å tilby sine kunder tjenester og produkter innen:"
              listElements={advantagesList}
            />

            <div className="mt-40 pb-40 border-b md:border-none">
              <p className="mt-16 mb-0">
                Disse verktøyene gjør at bruktbilforhandleren kan tilby samme trygghet i et bilsalg som en
                nybilforhandler.
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default MobilityPool;
